module.exports = __webpack_public_path__ + "static/media/banner-3.86e6bd2d.jpeg";